module.exports = __webpack_public_path__ + "img/service_고령친화요양산업.0e395ce8.png";